import React, { useRef } from 'react';
import {
  useIframeNavigationSync,
  NavigationMessage,
} from '../hooks/useIframeNavigationSync';
import { getAllowedOrigins } from '../utils/iframeOrigins';

export interface IframeWithNavigationSyncProps {
  src: string;
  title: string;
  style?: React.CSSProperties;
  allow?: string;
  onNavigationMessage?: (message: NavigationMessage) => void;
  debugMode?: boolean;
  className?: string;
  onLoad?: () => void;
}

export const IframeWithNavigationSync: React.FC<
  IframeWithNavigationSyncProps
> = ({
  src,
  title,
  style = {
    width: '100%',
    height: '100%',
    border: 'none',
  },
  allow,
  onNavigationMessage,
  debugMode = false,
  className,
  onLoad,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useIframeNavigationSync({
    allowedOrigins: getAllowedOrigins(),
    iframeRef,
    onNavigationMessage,
    debugMode,
  });

  const handleLoad = () => {
    if (debugMode) {
      console.log(`[IframeWithNavigationSync] Iframe loaded: ${title}`);
    }
    onLoad?.();
  };

  return (
    <iframe
      key={src} // Force remount when URL changes to prevent browser history issues
      ref={iframeRef}
      src={src}
      title={title}
      style={style}
      allow={allow}
      className={className}
      onLoad={handleLoad}
    />
  );
};
